import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function await_0(_this__u8e3s4, $completion) {
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.ra5();
  var cont = cancellable;
  var tmp = (it) => {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = cont;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
    this_0.rc(tmp$ret$0);
    return Unit_instance;
  };
  _this__u8e3s4.then(tmp, (it) => {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = cont;
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(it));
    this_0.rc(tmp$ret$2);
    return Unit_instance;
  });
  return cancellable.sa5();
}
//region block: exports
export {
  await_0 as awaitukrc63zn80a8,
};
//endregion

//# sourceMappingURL=afterTimeout.js.mjs.map
